import { put, select, call, takeLatest } from 'redux-saga/effects';

import { updateWizardCurrentPath, notifyNavigationChange } from '../actions';
import { BROWSER_NAV_FWD, BROWSER_NAV_BCK } from '../constants/heapEvents';
import { track } from '../lib/heapHelpers';
import { findByUrl } from '../lib/wizard/wizardPathHelpers';
import { wizardNextStepSelector, wizardPathsSelector } from '../reducers/selectors';

function* navigationWatcher() {
  yield takeLatest('@@router/LOCATION_CHANGE', navigationWorker);
}

function* navigationWorker(action) {
  const route = action.payload.location.pathname;
  const currentWizardPath = yield select(wizardNextStepSelector);

  if (route !== currentWizardPath) {
    yield put(updateWizardCurrentPath(route));
  }

  const wizardPaths = yield select(wizardPathsSelector);
  if (action.payload.action === 'POP' && wizardPaths) {
    const currentPathIndex = findByUrl(currentWizardPath, wizardPaths);
    const nextPathIndex = findByUrl(route, wizardPaths);

    if (currentPathIndex > nextPathIndex) {
      yield call(track, BROWSER_NAV_BCK, {
        'Application Previous Path': currentWizardPath,
        'Application Next Path': route,
      });
    }

    if (currentPathIndex < nextPathIndex) {
      yield call(track, BROWSER_NAV_FWD, {
        'Application Previous Path': currentWizardPath,
        'Application Next Path': route,
      });
    }
  }

  yield put(notifyNavigationChange(route));
}

export { navigationWorker };
export default navigationWatcher;
